<template>
  <el-container>
    <el-header>
      <Header></Header>
    </el-header>
    <el-container>
      <Siderbar></Siderbar>
      <el-container>
        <el-main>
          <Breadcrumb></Breadcrumb>
          <transition name="fade-transform" mode="out-in">
            <router-view>
            </router-view>
          </transition>
        </el-main>
        <el-footer>
          <Footer></Footer>
        </el-footer>
      </el-container>
    </el-container>
    <Scrolltotop></Scrolltotop>
    <audio autoplay="autoplay"
           :src="currentSong"
           style="display: none"
           id="audio"
    >
    </audio>
  </el-container>
</template>

<script>
import Header from '../../components/header/StoreHeader'
import Breadcrumb from '../../components/breadcrumb/Breadcrumb'
import Footer from '../../components/footer/Footer'
import Siderbar from '../../components/sidebar/StoreSidebar'
import Scrolltotop from '../../components/scrolltotop/Scrolltotop'
import ResizeMixin from '@/utils/resizeHandler'


export default {
  name: 'Full',
  components: {
    Header,
    Breadcrumb,
    Footer,
    Siderbar,
    Scrolltotop
  },
  mixins: [ResizeMixin],
  computed: {
  },
  data () {
    return {
      websocketUrl:window.server.websocketUrl,
      socket:null,
      newOrderplayUrl:"/admin/static/order_tip.mp3",
      newMsgplayUrl:"/admin/static/new_msg.mp3",
      audio:null,
      currentSong:null,
      timer:null,
    }
  },
  created () {
  },
  mounted () {
    // 初始化
    this.initWebsocket()
  },
  methods: {
    initWebsocket() {


      if(typeof(WebSocket) === "undefined"){
        alert("您的浏览器不支持订单提醒推送");//TODO 改为定时拉取
      }else{

        var storage = window.localStorage;
        var user = JSON.parse(storage["user"]);
        var accessToken = storage["access_token"];
        var url = this.websocketUrl+accessToken;
        console.log(url);
        // 实例化socket
        this.socket = new WebSocket(url)
        // 监听socket连接
        this.socket.onopen = this.open
        // 监听socket错误信息
        this.socket.onerror = this.error
        // 监听socket消息
        this.socket.onmessage = this.getMessage

        this.timer = setInterval(this.send, 10000);

        console.log(url)
      }
    },
    open: function (e) {
      console.log("socket连接成功", e)
    },
    error: function (e) {
      console.log("连接错误", e)
    },
    getMessage: function (msg) {
      var data = msg.data;
      console.log("收到数据")
      console.log(data)
      data = JSON.parse(data);
      if (data.type == 2) {//新订单
          this.$notify({
            title: data.des,
            dangerouslyUseHTMLString: true,
            message: "订单号:" + data.params.order_no+"<br/>"+"桌号:"+data.params.table_number,
            duration:5000,
            position: 'bottom-right',
            type:"success"
          });
          this.audio = window.document.getElementById('audio');
          if(this.currentSong == null || this.currentSong != this.newOrderplayUrl){
            this.currentSong = this.newOrderplayUrl;
          }else{
            this.audio.play();
          }
      }else if(data.type == 3){//订单支付
          this.$notify({
            title: data.des,
            dangerouslyUseHTMLString: true,
            message: "订单号:" + data.params.order_no+"<br/>"+"桌号:"+data.params.table_number,
            duration:5000,
            position: 'bottom-right',
            type:"success"
          });
      }else if (data.type == 4) {//呼叫服务
        this.$notify({
          title: data.des,
          dangerouslyUseHTMLString: true,
          message: data.params.table_number+"号桌客人呼叫:" + data.params.call_content,
          duration: 5000,
          position: 'bottom-right',
          type: "success"
        });
        this.audio = window.document.getElementById('audio');
        if (this.currentSong == null || this.currentSong != this.newMsgplayUrl) {
          this.currentSong = this.newMsgplayUrl;
          console.log("eeeee");
        } else {
          this.audio.play();
        }
      }


      console.log(data)
    },
    send: function () {
      let params = {type:'-1',action:'online',data:'定时心跳'};
      this.socket.send(JSON.stringify(params))
    },
    close: function () {
      console.log("socket已经关闭")
      if(this.timer != null){
        clearInterval(this.timer);
      }
    },
  },
  destroyed () {
    // 销毁监听
    if(this.socket != null){
      this.socket.onclose = this.close();
      this.socket.close();
      this.socket = null;
    }
  }
}
</script>

<style scoped lang="stylus">
  @media (max-width: 920px)
    .el-main
      padding 0

  .el-header, .el-footer {
    color: #333;
    height: 50px !important;
    padding: 0;
  }

  .el-main {
    background-color: #f5f5f5;
    color: #333;
  }

  body > .el-container {
    margin-bottom: 40px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/store/Full.vue